// extracted by mini-css-extract-plugin
export default {"scrollableSection":"scrollable-section_scrollableSection__pb6Gy"};